import axios from 'axios';
import { API_URL } from '../constants';

const createInstance = ({ path }: { path: string }) => {
  const axiosInstance = axios.create({
    baseURL: `https://${API_URL}${path}`,
    withCredentials: true,
  });

  return axiosInstance;
};

export const http = {
  dashboard: createInstance({
    path: '/dashboard/api',
  }),
  accounts: createInstance({
    path: '/accounts',
  }),
};
